const getDefaultState = () => {
    return {
        sender: null,
        receiver: null,
        subject: '',
        firstPartEmail: '',
        lastPartEmail: '',
        signature: '',
        emailsValid: [],
        emailsWrong: [],
        alreadyInCampaign: [],
        sentAt: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedTags: [],
        selectedApidaeSelection: null,
        cadhType: null,
        providers: [],
        selectedCriterias: [],
        noEmail: false,
        singleEmail: true,
        currentStep: 1,
        filteredProviders: [],
        hasEntityAndProvider: null,
        cadhSelectionType: null,
        cadhConfigId: null,
    }
}

const createCadh = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setSender(state, value) {
            state.sender = value
        },
        setReceiver(state, value) {
            state.receiver = value
        },
        setSubject(state, value) {
            state.subject = value
        },
        setFirstPartMail(state, value) {
            state.firstPartEmail = value
        },
        setLastPartMail(state, value) {
            state.lastPartEmail = value
        },
        setSignature(state, value) {
            state.signature = value
        },
        setEmailsValid(state, value) {
            state.emailsValid = value
        },
        setEmailsWrong(state, value) {
            state.emailsWrong = value
        },
        setAlreadyInCampaign(state, value) {
            state.alreadyInCampaign = value
        },
        setSentAt(state, value) {
            state.sentAt = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedApidaeSelection(state, value) {
            state.selectedApidaeSelection = value
        },
        setCadhType(state, value) {
            state.cadhType = value
        },
        setSelectedCriterias(state, value) {
            state.selectedCriterias = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setProviders(state, value) {
            state.providers = value
        },
        setProviderByIndex(state, [index, value]) {
            state.providers[index] = value
        },
        setNoEmail(state, value) {
            state.noEmail = value
        },
        setSingleEmail(state, value) {
            state.singleEmail = value
        },
        setFilteredProviders(state, value) {
            state.filteredProviders = value
        },
        setHasEntityAndProvider(state, value) {
            state.hasEntityAndProvider = value
        },
        setCadhConfigId(state, value) {
          state.cadhConfigId = value
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default createCadh